<mat-icon
	class="{{ data?.status }}"
	[ngClass]="data?.status + '-icon'"
	svgIcon="{{ data?.icon }}"
></mat-icon>
<span class="{{ data?.status }}" [innerHTML]="data?.message"></span>
